export const ADD_PERMISSION = 'ADD_PERMISSION';
export const CLEAR_PERMISSION = 'CLEAR_PERMISSION';

export interface IAuth {
  authToken?: string;
  expiresOn?: Date;
  loggedIn?: boolean | null;
  permissions: string[];
  hasWriteAccess: boolean;
  hasInternalAccess: boolean;
  hasProjectServiceRead: boolean;
  hasProjectServiceWrite: boolean;
  hasProjectServiceUiAccess: boolean;
  sub: string;
  userLanguage?: string;
}

export const addAuthValues = (authValues: IAuth) => ({
  type: ADD_PERMISSION,
  authValues,
});

export const clearAuthValues = () => ({
  type: CLEAR_PERMISSION,
});
